import { get } from '../axios/axiosGateway';

export const getFeatures = params => {
  return get('/features', params);
};
